import React, { useEffect, useState } from 'react';
import './AdminHome.css';
import { Briefcase, Users } from 'lucide-react';

function AdminHome({ setActiveTab }) {
  const [jobCount, setJobCount] = useState(0);
  const [applicantCount, setApplicantCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [jobRes, applicantRes] = await Promise.all([
          fetch('http://localhost:3000/api/jobs/count'),
          fetch('http://localhost:3000/api/applicants/count'),
        ]);

        if (!jobRes.ok || !applicantRes.ok) {
          throw new Error('Failed to fetch data');
        }

        const jobData = await jobRes.json();
        const applicantData = await applicantRes.json();

        setJobCount(jobData.count || 0);
        setApplicantCount(applicantData.count || 0);
      } catch (error) {
        console.error('Error fetching counts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return (
    <div className="admin-home">
      <h2 className="home-title">Dashboard Summary</h2>
      <div className="cards">
        <div className="card card-jobs" onClick={() => setActiveTab('jobs')}>
          <div className="card-inner">
            <div className="card-icon-wrapper">
              <Briefcase className="card-icon" size={40} />
            </div>
            <div className="card-info">
              <h3 className="card-title">Total Jobs</h3>
              <p className="card-count">{loading ? '' : jobCount}</p>
            </div>
          </div>
        </div>

        <div className="card card-applicants" onClick={() => setActiveTab('applicants')}>
          <div className="card-inner">
            <div className="card-icon-wrapper">
              <Users className="card-icon" size={40} />
            </div>
            <div className="card-info">
              <h3 className="card-title">Total Applicants</h3>
              <p className="card-count">{loading ? '' : applicantCount}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHome;
